// MODULES
import React from "react";

import OptionsList from "../../../../../../components/OptionsList/OptionsList";
import {createClassName, localeNumber} from "@helpers/utils";
import Slider from "../../../../../../../../components/Slider/Slider";
import CheckboxWithName from "../../../../../../components/CheckboxWithName/CheckboxWithName";


export default class Collection extends React.PureComponent {

	netDescriptionString = "Vid nettodepå går den tredjepartsersättning från fonder som annars tillfaller rådgivaren tillbaka till kunds depå.";
	adminCostString = "En fast administrationsavgift om 39kr/mån tas ut per kvartal per kund.";

	render() {
		const {props} = this;
		const {index, fields, session, onOptionsListChange, onCheckboxChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		const insuranceAccountText = "Danica-blanketterna samt handelsfullmakten " +
			" behöver fyllas i och signeras fysiskt utanför detta verktyg. När depån öppnats hos Nord " +
			" fyller ni i depånumret på dessa handlingar och postar dem i original till Danica.";

		const noticeStyleYellow = {
			marginTop: "15px",
			maxWidth: "450px",
			padding: "10px",
			background: "#FBF1D7",
			border: "1px solid #f7e2a8",
			borderRadius: "3px",
			lineHeight: "20px"
		};

		const noticeStyleGray = {
			marginTop: "15px",
			width: "100%",
			flex: "1",
			padding: "10px",
			background: "#f4f5f7",
			color: "#91a0ad",
			borderRadius: "3px",
			fontSize: "12px"
		};

		const noticeStyleGrayNet = {
			marginTop: "5px",
			width: "100%",
			flex: "1",
			padding: "10px",
			background: "#f4f5f7",
			color: "#91a0ad",
			borderRadius: "3px",
			fontSize: "12px"
		};

		let partnerRole = "radgivare";
		if (session.context && session.context.partner && session.context.partner.role) {
			partnerRole = session.context.partner.role;
		}

		let accountOptions;
		if (session.isCompany) {
			accountOptions = (
				<React.Fragment>
					<OptionsList
						type="radio"
						description="Kontotyp"
						name="customer_account_type_company"
						orientation="horizontal"
						options={fields.customer_account_type_company.options}
						onChange={onOptionsListChange}
					/>

					{fields.customer_account_type_company.options[0].checked && (
						<div style={noticeStyleYellow}>{insuranceAccountText}</div>
					)}
				</React.Fragment>
			);
		}
		else {
			accountOptions = (
				<React.Fragment>
					<OptionsList
						type="radio"
						description="Kontotyp"
						orientation="horizontal"
						name="customer_account_type_person"
						options={fields.customer_account_type_person.options}
						onChange={onOptionsListChange}
					/>

					{fields.customer_account_type_person.options[1].checked && (
						<div style={noticeStyleYellow}>{insuranceAccountText}</div>
					)}
				</React.Fragment>
			);
		}

		let shouldShowAccountTypeOption = session.context != null;

		return (
			<React.Fragment>

				{!shouldShowAccountTypeOption && (
					<React.Fragment>

						{session.isCompany && (
							<input type="hidden" name="checkbox_account_naked" value="yes"/>
						)}

						{!session.isCompany && (
							<input type="hidden" name="checkbox_account_isk" value="yes"/>
						)}

						<input type="hidden" name="radio_account_type_open" value="Net"/>
						<input type="hidden" name="account_account_fee" value="0,25%"/>
					</React.Fragment>
				)}

				{shouldShowAccountTypeOption && (
					<div className={classes} style={{width: "100%"}}>
						<h3>Val av konto</h3>
						{accountOptions}

						<OptionsList
							style={{marginTop: 20}}
							type="radio"
							description="Val av depåtyp"
							orientation="horizontal"
							name="radio_account_type_open"
							options={fields.radio_account_type_open.options}
							onChange={onOptionsListChange}
						/>

						{(fields.radio_account_type_open.options[0].checked ||
							fields.radio_account_type_open.options[1].checked ||
							fields.radio_account_type_open.options[2].checked) && (
							<div className="Cob-disclaimer" style={noticeStyleGray}>
								<div className="Cob-miniNote" style={{width: "100%"}}><p
									style={{margin: "0", width: "100%"}}>{this.adminCostString}</p></div>
								<input type="hidden" name="advice_portfolio_admincost" value={this.adminCostString}/>
							</div>
						)}

						{(fields.radio_account_type_open.options[1].checked ||
							fields.radio_account_type_open.options[2].checked) && (
							<div className="Cob-disclaimer" style={noticeStyleGrayNet}>
								<div className="Cob-miniNote" style={{width: "100%"}}><p
									style={{margin: "0", width: "100%"}}>{this.netDescriptionString}</p></div>
								<input type="hidden" name="advice_portfolio_netto" value={this.netDescriptionString}/>
							</div>
						)}

						{(fields.radio_account_type_open.options[0].checked ||
							fields.radio_account_type_open.options[1].checked ||
							fields.radio_account_type_open.options[2].checked) && (
							<React.Fragment>

								<input type="hidden" name="account_disk_fee" value=""/>

								{partnerRole === "disk" && !fields.radio_account_type_open.options[0].checked && (
									<React.Fragment>
										<div className="fields" style={{
											width: "100%",
											flexDirection: "row",
											marginTop: "15px"
										}}>
											<div className="column" style={{
												width: "50%",
												flexDirection: "row",
												paddingRight: "5px"
											}}>
												<CheckboxWithName
													name="newAccountCheckbox5"
													style={{marginTop: 28, marginRight: 10}}
													checked={fields.newAccountCheckbox5.checked}
													onChange={onCheckboxChange}
												/>

												<Slider
													className="has-checkbox"
													label="Diskretionär avgift"
													unit="%"
													value={fields.newAccountSlider5}
													min={0.1}
													max={3}
													step={0.05}
													visibleValues={["0,10", "3,00"]}
													valueFormatter={this._sliderValueFormatter}
													disabled={!fields.newAccountCheckbox5.checked}
													onChange={this._onSlider5Change.bind(this)}
												/>
											</div>
										</div>
										<input type="hidden" name="account_disk_fee" value={
											fields.newAccountCheckbox5.checked ? fields.newAccountSlider5 + "%" : ""}/>
									</React.Fragment>
								)}

								<div className="fields" style={{
									width: "100%",
									flexDirection: "row",
									marginTop: "20px"
								}}>
									<div className="column" style={{
										flex: 1,
										flexDirection: "row",
										marginRight: "5px"
									}}>
										<FeeSlider
											number={1}
											fields={fields}
											name="account_account_fee"
											label="Depåavgift"
											valueFormatter={this._sliderValueFormatter}
											onCheckboxChange={onCheckboxChange}
											onChange={this._onSlider1Change.bind(this)}
											hasCheckbox
										/>
									</div>

									<div className="column" style={{
										flex: 1,
										flexDirection: "row",
										marginLeft: "5px"
									}}>
										<FeeSlider
											number={2}
											fields={fields}
											name="account_advice_fee"
											label="Rådgivningsavgift"
											valueFormatter={this._sliderValueFormatter}
											onCheckboxChange={onCheckboxChange}
											onChange={this._onSlider2Change.bind(this)}
											hasCheckbox
										/>
									</div>
								</div>
							</React.Fragment>
						)}

						{fields.radio_account_type_open.options[2].checked && (
							<div className="fields" style={{
								width: "100%",
								flexDirection: "row",
								marginTop: "20px"
							}}>
								<div className="column" style={{
									flex: 1,
									flexDirection: "row",
									marginRight: "5px"
								}}>
									<Slider
										label="Resultatbaserad avgift" unit="%"
										value={fields.newAccountSlider3}
										min={1} max={20}
										visibleValues={["1,00", "20,00"]}
										valueFormatter={this._sliderValueFormatter}
										onChange={this._onSlider3Change.bind(this)}
									/>
									<input type="hidden" name="account_performance_fee"
										   value={fields.newAccountSlider3 + "%"}/>
								</div>

								<div className="column" style={{
									flex: 1,
									flexDirection: "row",
									marginLeft: "5px"
								}}>
									<CheckboxWithName
										name="newAccountCheckbox3"
										style={{marginTop: 28, marginRight: 10}}
										checked={fields.newAccountCheckbox3.checked}
										onChange={onCheckboxChange}
									/>

									<Slider
										className="has-checkbox"
										label="Avkastningströskel" unit="%"
										value={fields.newAccountSlider4}
										min={1} max={25}
										visibleValues={["1,00", "25,00"]} valueFormatter={this._sliderValueFormatter}
										disabled={!fields.newAccountCheckbox3.checked}
										onChange={this._onSlider4Change.bind(this)}
									/>
									<input type="hidden" name="account_performance_hurdle_fee" value={
										fields.newAccountCheckbox3.checked ? fields.newAccountSlider4 + "%" : ""}/>
								</div>
							</div>
						)}

					</div>
				)}

				<div className={classes}>

					<h3>Fullmakt</h3>

					<OptionsList
						type="radio"
						description=""
						orientation="horizontal"
						name="radio_reseller_poa"
						options={fields.radio_reseller_poa.options}
						onChange={onOptionsListChange}
					/>

					<div className="Cob-disclaimer" style={noticeStyleGray}>
						<div className="Cob-miniNote" style={{width: "100%"}}>
							{fields.radio_reseller_poa.options[0].checked ? (
								<p style={{margin: "0", width: "100%"}}>
									Härmed lämnar jag/vi nedan angivna ombud fullmakt att för min/vår räkning
									erhålla uppgift om min/vår kontoställning, mitt/vårt depåinnehav och mina
									hos Nord Fondkommission, inklusive tidigare enomförda affärer. Fullmakten
									gäller samtliga mina/våra nuvarande och blivande depåer/konton hos Nord
									Fondkommission. Om två eller fler personer angivits som ombud gäller
									fullmakten för dem var för sig. Om fullmaktsgivaren och/eller ombud är
									juridisk person ska handlingar som utvisar vem som tecknar firman bifogas
									(max 6 månader gamla). Ombud får inte sätta annan i sitt ställe. Om firma
									angivits som ombud åligger det ombudet att tillse att Nord Fondkommission
									skriftligen hålls uppdaterad avseende förteckningen över befintliga
									firmatecknare.
								</p>
							) : ""}

							{fields.radio_reseller_poa.options[1].checked ? (
								<p style={{margin: "0", width: "100%"}}>
									Härmed lämnar jag/vi angivna ombudet fullmakt att för min/vår räkning erhålla
									uppgift om min/vår kontoställning, mitt/vårt depåinnehav, och mina hos Nord
									Fondkommission, inklusive tidigare, genomförda affärer samt, på kundens uppdrag,
									genomföra flytt av likvider mellan mina depåer hos Nord Fondkommission. Fullmakten
									gäller samtliga mina/våra nuvarande och blivande depåer/konton hos Nord
									Fondkommission. Om två eller fler personer angivits som ombud gäller fullmakten för
									dem var för sig. Om fullmaktsgivaren och/eller ombud är juridisk person ska
									handlingar som utvisar vem som tecknar firman bifogas (max 6 månader gamla). Ombud
									får inte sätta annan i sitt ställe. Om firma angivits som ombud åligger det ombudet
									att tillse att Nord Fondkommission skriftligen hålls uppdaterad avseende
									förteckningen över befintliga firmatecknare.
								</p>
							) : ""}

							{fields.radio_reseller_poa.options.length > 2 && (
								<React.Fragment>
									{fields.radio_reseller_poa.options[2].checked ? (
										<p style={{margin: "0", width: "100%"}}>
											Härmed lämnar jag/vi angivna ombudet fullmakt att för min/vår räkning erhålla
											uppgift om min/vår kontoställning, mitt/vårt depåinnehav och mina hos Nord
											Fondkommission, inklusive tidigare, genomförda affärer. Förvärva, avyttra och
											förfoga över värdepapper och andra rättigheter. Om två eller fler personer angivits
											som ombud gäller fullmakten för dem var för sig. Om fullmaktsgivaren och/eller ombud
											är juridisk person ska handlingar som utvisar vem som tecknar firman bifogas (max 6
											månader gamla). Ombud får inte sätta annan i sitt ställe. Om firma angivits som
											ombud åligger det ombudet att tillse att Nord Fondkommission skriftligen hålls
											uppdaterad avseende förteckningen över befintliga firmatecknare.
										</p>
									) : ""}

									{fields.radio_reseller_poa.options[3].checked ? (
										<p style={{margin: "0", width: "100%"}}>
											Härmed lämnar jag/vi angivna ombudet fullmakt att för min/vår räkning erhålla
											uppgift om min/vår kontoställning, mitt/vårt depåinnehav och mina hos Nord
											Fondkommission, inklusive tidigare, genomförda affärer. Förvärva, avyttra och
											förfoga över värdepapper i syfte att placera eller omplacera tillgångar i depån. Likvida
											medel får disponeras i syfte att genomföra placeringar eller att göra utbetalningar
											enligt depåhavarens instruktioner till föranmält konto som tillhör depåhållaren. Om
											två eller fler personer angivits som ombud gäller fullmakten för dem var för sig. Om
											fullmaktsgivaren och/eller ombud är juridisk person ska handlingar som utvisar vem
											som tecknar firman bifogas (max 6 månader gamla). Ombud får inte sätta annan i sitt
											ställe. Om firma angivits som ombud åligger det ombudet att tillse att Nord
											Fondkommission skriftligen hålls uppdaterad avseende förteckningen över befintliga
											firmatecknare. Det åligger den diskretionära förvaltaren att ett ingånget
											diskretionärt avtal finns med kunden och att den diskretionära förvaltaren
											efterlever gällande lagar, föreskrifter och de villkor som överenskommit. Uppsägning
											av diskretionärt avtal ska göras hos ombudet och Nord Fondkommission. Uppsägning av denna fullmakt görs hos Nord Fondkommission. Om det
											Diskretionära avtalet sägs upp, sägs denna fullmakt upp samtidigt.
										</p>
									) : ""}
								</React.Fragment>
							)}
						</div>
						<input type="hidden" name="advice_portfolio_admincost" value={this.adminCostString}/>
					</div>
				</div>
			</React.Fragment>
		);
	}

	_sliderValueFormatter = (value) => value.toFixed(2).replace(".", ",");

	_onSlider1Change(value) {
		this.props.onFieldChange.call(this, "newAccountSlider1", value)
	}

	_onSlider2Change(value) {
		this.props.onFieldChange.call(this, "newAccountSlider2", value)
	}

	_onSlider3Change(value) {
		this.props.onFieldChange.call(this, "newAccountSlider3", value)
	}

	_onSlider4Change(value) {
		this.props.onFieldChange.call(this, "newAccountSlider4", value)
	}

	_onSlider5Change(value) {
		this.props.onFieldChange.call(this, "newAccountSlider5", value)
	}
}

class FeeSlider extends React.PureComponent {

	render() {
		const {props} = this;
		const {name, label, valueFormatter, hasCheckbox, onCheckboxChange, onChange} = props;

		let checkboxName = "newAccountCheckbox" + this.props.number;

		return (
			<React.Fragment>
				{hasCheckbox === true && (
					<CheckboxWithName
						name={checkboxName}
						style={{marginTop: 28, marginRight: 10}}
						checked={!!this._getCheckboxValue()}
						disabled={this._getSliderMaxValue() === 0}
						onChange={onCheckboxChange}
					/>
				)}
				<Slider
					className={createClassName("FeeSlider", {"has-checkbox": hasCheckbox === true})}
					unit="%"
					label={label}
					value={this._getSliderValue()}
					min={this._getSliderMinValue()}
					max={this._getSliderMaxValue()}
					step={0.05}
					showValues={!!this._getCheckboxValue()}
					valueFormatter={valueFormatter}
					disabled={!this._getCheckboxValue()}
					onChange={onChange}
				/>
				<input type="hidden" name={name}
					   value={this._getCheckboxValue() ? valueFormatter(this._getSliderValue()) + "%" : ""}/>
			</React.Fragment>
		);
	}

	// Internal methods
	_getCheckboxValue() {
		let checkboxName = "newAccountCheckbox" + this.props.number;
		return this.props.fields[checkboxName].checked;
	}

	_getSliderValue = () => {
		const checkboxChecked = !!this._getCheckboxValue();

		if (checkboxChecked) {
			/**
			 * Set up default values if user hasn't changed them manually
			 */
			if (this.props.fields["newAccountSlider" + this.props.number] === "") {
				if (this.props.number === 1) {

					if (this.props.fields.radio_account_type_open.options[0].checked) { // Brutto type
						return 0.85;
					}

					return 0.95; // Net and net performance based

				}
				else if (this.props.number === 2) {

					if (this.props.fields.radio_account_type_open.options[0].checked) { // Brutto type
						return 0.15;
					}
					else if (this.props.fields.radio_account_type_open.options[1].checked) { // Net type
						return 1.05;
					}

					return 0.55; // Net performance based type
				}

				return this._getSliderMinValue();
			}

			return Math.max(Math.round(this.props.fields[`newAccountSlider${ this.props.number }`] * 100) / 100, this._getSliderMinValue());
		}
		else {
			return 0;
		}
	};

	_getSliderMinValue = (format = false) => {
		const minValue = this.props.fields.radio_account_type_open.options[0].checked ? 0.15 : 0.1;
		const formatValue = number => format === true ? localeNumber(number) : number;
		return !!this._getCheckboxValue() ? formatValue(minValue) : formatValue(0);
	};

	_getSliderMaxValue = (format = false) => {
		const {props} = this;
		const {number, fields} = props;
		const formatValue = number => format === true ? localeNumber(number) : number;
		const maxValue = (
			fields.radio_account_type_open.options[0].checked ? 1 :
				fields.radio_account_type_open.options[1].checked ? 2 :
					1.5
		);

		if (number === 1) { // Max value for Slider 1
			if (!fields.newAccountCheckbox2.checked) { // Slider 2 is not active
				return formatValue(maxValue);
			}

			/**
			 * Slider 2 was active so the max value for slider 1 is the max value minus whatever slider 2 is set to.
			 * Return a toFixed value since javascript floating point arithmetic sometimes causes us to end up with
			 * a lot of decimals (similar to .0000000001).
			 */
			const sliderMaxValue = maxValue - (fields.newAccountSlider2 || this._getSliderMinValue());
			return formatValue(sliderMaxValue.toFixed(2));
		}

		if (number === 2) {
			if (!fields.newAccountCheckbox1.checked) { // Slider 1 is not active
				return formatValue(maxValue);
			}

			/**
			 * Slider 1 was active so the max value for slider 2 is the max value minus whatever slider 1 is set to.
			 * Return a toFixed value since javascript floating point arithmetic sometimes causes us to end up with
			 * a lot of decimals (similar to .0000000001).
			 */
			const sliderMaxValue = maxValue - (fields.newAccountSlider1 || this._getSliderMinValue());
			return formatValue(sliderMaxValue.toFixed(2));
		}

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/nordfk-cob/Fields/collections/CollectionAccountType.js